import * as Yup from "yup";

const clienteValidator = Yup.object().shape({
  indicadorConsumidorFinal: Yup.boolean().required("Consumidor Final"),
  tipoContribuinteId: Yup.number().required("Tipo Contribuinte"),
  tabelaPrecoPadrao: Yup.number().nullable(),
  mensagemVenda: Yup.string().nullable(),
  limiteCompra: Yup.number().nullable(),
  grupoPessoaId: Yup.number().nullable(),
  sugestaoVendedorId: Yup.number().nullable(),
  meiosPagamento: Yup.array().nullable(),
  dependentes: Yup.array()
    .of(
      Yup.object().shape({
        nome: Yup.string().required("Nome do dependente"),
        dataNascimentoDependente: Yup.date().required(
          "Data de nascimento dependente"
        ),
        celularDependente: Yup.string().required("Celular do dependente"),
      })
    )
    .nullable(),
});

export default clienteValidator;
